module.exports = __webpack_public_path__ + "img/facility-1.809158a2.png";